module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/realEstate-16e3a29b2eace419ba3b3656b8f15d8b.jpg";